import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    fontSize: 10,
  },
});

export default function BreakTextFields({ breakPrice, dispatchBreak }) {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(breakPrice.priceToBreak);
  useEffect(() => {
    setInputValue(breakPrice.priceToBreak);
  }, [breakPrice]);
  return (
    <>
      <Grid item xs={3}>
        <TextField
          className={classes.root}
          value={inputValue}
          variant="outlined"
          size="small"
          style={{ backgroundColor: "white", width: "100%" }}
          inputProps={{ style: { fontSize: 10 } }}
          onChange={(ev) => setInputValue(ev.target.value)}
          onBlur={(ev) =>
            dispatchBreak({ priceToBreak: parseFloat(ev.target.value) })
          }
          label={<Typography style={{ fontSize: 10 }}>price</Typography>}
        >
          <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
        </TextField>
      </Grid>
    </>
  );
}
